<div class="lib-pagination-bar">
  <div class="pagination-summary">
    @if (isTurkish) { Toplam {{ totalItems }} kayıttan {{ startItem }}-{{
      endItem
    }}
    arası gösteriliyor } @else { Showing {{ startItem }}-{{ endItem }} of
    {{ totalItems }} records }
  </div>

  <div class="pagination-actions">
    @if (showPageSizeSelector) {
    <div class="pagination-page-size">
      <label class="pagination-page-size-label" for="pagination-page-size-select">
        @if (isTurkish) { Göster: } @else { Show: }
      </label>
      <select
        id="pagination-page-size-select"
        class="pagination-page-size-select"
        [ngModel]="pageSize"
        (ngModelChange)="onPageSizeChange($event)"
      >
        @for (option of pageSizeOptions; track option) {
        <option [ngValue]="option">{{ option }}</option>
        }
      </select>
    </div>
    }

    <div class="pagination-controls-modern">
    <button
      type="button"
      class="pagination-nav-btn"
      [disabled]="!hasPrevPage"
      (click)="onPageChange(currentPage - 1)"
      aria-label="Önceki"
    >
      <svg lucideChevronLeft [size]="16" [strokeWidth]="2"></svg>
    </button>

    @for (page of pageNumbers; track page) {
    <button
      type="button"
      class="pagination-page-btn"
      [class.active]="page === currentPage"
      (click)="onPageChange(page)"
    >
      {{ page + 1 }}
    </button>
    }

    <button
      type="button"
      class="pagination-nav-btn"
      [disabled]="!hasNextPage"
      (click)="onPageChange(currentPage + 1)"
      aria-label="Sonraki"
    >
      <svg lucideChevronRight [size]="16" [strokeWidth]="2"></svg>
    </button>
    </div>
  </div>
</div>
